import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider } from "@material-ui/core";
import { showModal } from "../../../actions/actionCreators";
import LocalNavMenu from "../LocalNavMenu";
import {
    getManageAccountItems,
    getCoreToolsItems,
    getCountAndDeploymentItems,
    getDiscoveryAndDataItems,
    getVariablesItems,
    getScriptNodeSearchItems,
} from "./ToolsMenuSections";

export default function ToolsMenu() {
    const dispatch = useDispatch();
    const pathname = useSelector(state => state.router.location.pathname);
    const roles = useSelector(state => state.session.roles);
    const enabledFeatures = useSelector(state => state.session.enabledFeatures);
    const companyId = useSelector(state => state.session.companyId);
    const pwExpired = useSelector(state => state.session.pwExpired);

    const hasSuperAdmin = roles.includes("Super Admin");
    const hasExperianAdmin = roles.includes("Experian Admin");
    const canSeeAutomation = hasSuperAdmin || hasExperianAdmin;

    const wayfarerMode = enabledFeatures.includes("integrate-wayfarer-header");
    const hasOfferCodes = enabledFeatures.includes("offer-codes");
    const hasRadiusHidden = enabledFeatures.includes("radius-hide");
    const hasClientVariablesManagement = enabledFeatures.includes("client-variables-management");
    const hasScriptNodeSearch = enabledFeatures.includes("script-node-search");
    const canManageVariables = hasSuperAdmin || hasExperianAdmin || hasClientVariablesManagement;

    const handleOfferCodes = useCallback(
        () => dispatch(showModal("VARIABLE_ADMIN", { scope: "OfferCode" })),
        [dispatch]
    );
    const handleVariables = useCallback(
        () => dispatch(showModal("VARIABLE_ADMIN", { scope: "CampaignFlow" })),
        [dispatch]
    );
    const handleVariableGroupings = useCallback(() => dispatch(showModal("VARIABLE_GROUPING")), [dispatch]);
    const handleRadiusFilters = useCallback(() => dispatch(showModal("AUDIENCE_RADIUS")), [dispatch]);
    const handleScriptNodeSearch = useCallback(() => dispatch(showModal("SCRIPT_NODE_SEARCH")), [dispatch]);

    const hasCompanySelected = companyId != null && companyId > 0;
    if (!hasCompanySelected) return null;

    const isActive = pathname.includes("/tools/");
    const audienceDiscoverySegmentsName = "Audience Insights Segments";

    // Build section groups
    const groups = [
        getManageAccountItems({ wayfarerMode, pwExpired }),
        getCoreToolsItems(),
        getCountAndDeploymentItems(), // separated section for Count Log & Deployment Queue
        getDiscoveryAndDataItems({ audienceDiscoverySegmentsName, canSeeAutomation }),
        getVariablesItems({
            hasOfferCodes,
            canManageVariables,
            hasRadiusHidden,
            hasSuperAdmin,
            onOfferCodes: handleOfferCodes,
            onVariables: handleVariables,
            onVariableGroupings: handleVariableGroupings,
            onRadiusFilters: handleRadiusFilters,
        }),
        getScriptNodeSearchItems({ show: hasScriptNodeSearch, onClick: handleScriptNodeSearch }),
    ];

    // Flatten with Divider between non-empty groups (no leading/trailing divider)
    const items = [];
    groups.forEach((group, idx) => {
        if (!group || group.length === 0) return;
        if (items.length > 0) {
            items.push(<Divider key={`tools-divider-${idx}`} name="divider" />);
        }
        items.push(...group);
    });

    return (
        <li id="tools" className={`menu-li ${isActive ? "active" : ""}`}>
            <LocalNavMenu id="tools-menu" key="tools" text="Tools" isCollapsed collapsedIcon="/Images/Icons/tools.png">
                {items}
            </LocalNavMenu>
        </li>
    );
}
